import Select, { SingleValue } from 'react-select';
import './select-dropdown-grouped.scss';
import { useRef } from 'react';
import useInputValidation from '../../../hooks/input-validation-hook';
import {rootContainer, TYPE} from "../../../services/container/root";
import IsMobileService from "../../../services/is-mobile-service/is-mobile-service";
import { DROPDOWN_MENU_WIDTH } from '../select-dropdown/select-dropdown';
import InputErrorMessages from '../input-error-messages/input-error-messages';
import { IValidationProps } from '../input/input';

export interface ISelectDropdownGroupedProps extends IValidationProps {
    options: GroupedOption[],
    placeholder?: string,
    value?: IOption,
    onChange?: (e: SingleValue<IOption>) => any;
    isLoading?: boolean;
    menuIsOpen?: boolean;
    menuWidth?: DROPDOWN_MENU_WIDTH;
    disabled?: boolean;
    target?: HTMLElement | null;
    isSearchable?: boolean;
}

export interface IOption {
    value: string | number,
    label: React.ReactNode,
    isDisabled?: boolean,
    category?: React.ReactNode,
}

export interface GroupedOption {
    readonly category?: React.ReactNode;
    readonly options: IOption[];
}

const formatGroupLabel = (data: GroupedOption) => {
    if (!data.category) {
        return;
    }
    else {
        return <span>{data.category}</span>;
    }
};

export const SelectDropdownGrouped: React.FC<ISelectDropdownGroupedProps> = ({ 
    options, placeholder, value, onChange, isLoading, menuIsOpen, menuWidth = DROPDOWN_MENU_WIDTH.FIT_CONTENT, disabled = false, target = document.body, required, validationGroup, validationCallback, showValidationMessage, isSearchable = true }) => {

    const { isValid, messages } = useInputValidation({ value : value ? value.value : '', validation: { validationGroup, required, validationCallback, showValidationMessage } });
    const isPad = rootContainer.get<IsMobileService>(TYPE.IsMobileService).isIPad();
    
    const ref = useRef<HTMLDivElement | null>(null);
    return (
        <>
        <div ref={ref} className={`select-dropdown-grouped${!isValid ? ' invalid' : ''}`}>
            <Select<IOption, false, GroupedOption>
                value={value}
                isDisabled={disabled}
                placeholder={placeholder}
                className="select-dropdown-grouped-container"
                classNamePrefix="select-dropdown-grouped"
                options={options}
                formatGroupLabel={formatGroupLabel}
                onChange={onChange}
                isLoading={isLoading}
                menuIsOpen={menuIsOpen}
                menuPortalTarget={target}
                isSearchable={isSearchable && !isPad}
                styles={{ 
                    menuPortal: base => {
                        return { ...base, zIndex: 101 }
                    },
                    menu: base => ({
                        ...base,
                        width: menuWidth,
                        minWidth: ref.current?.clientWidth + 'px',
                        maxWidth: '700px'
                    })
                }}
                menuPlacement="auto"
            />
        </div>
        <InputErrorMessages messages={messages} />
        </>
    );
};
